import { useEffect, useState } from "react";
import { getMessaging, getToken } from "firebase/messaging";
import config from "../../api/config";
import { messaging } from "../../firebase";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getSessionUserData } from "../../libs/user";
import client from "../../api/api";

const { FIREBASE_VAPID_KEY } = config;

  const {
    endpoints: { carrier },
  } = client;

export default function useRegisterToken() {
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const requestAndStoreToken = async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
          {
            scope: "/",
          }
        );
        const currentToken = await getToken(messaging, {
          vapidKey: FIREBASE_VAPID_KEY,
          serviceWorkerRegistration: registration,
        });

        if (currentToken) {
          setToken(currentToken);
          const { data } = getSessionUserData();
          await carrier.fbTokenToDB(data._id, currentToken);
        } else {
          throw new Error("No FCM token received");
        }
      } catch (err) {
        console.error("FCM error:", err);
        setError(err.message);
      }
    };

    if ("serviceWorker" in navigator && "Notification" in window) {
      requestAndStoreToken();
    } else {
      setError("Browser does not support notifications");
    }
  }, [location]);

  return { token, error };
}
